import { Session, Agenda as AgendaWidget } from '@eventmobi/widgets';
import { Button } from 'antd';
import Chance from 'chance';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

const noop = () => {};

const MockStyled = styled.div`
  background-color: #fff;
  overflow: hidden;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const Agenda = ({ title, footerProps, sessions }) => (
  <AgendaWidget
    title={title}
    footer={
      <Button
        type="default"
        style={{ borderColor: '#1976D2', color: '#1976D2' }}
        variant="outlined"
        onClick={noop}
      >
        {footerProps.buttonText}
      </Button>
    }
  >
    {sessions.map(({ key, ...session }) => (
      <div key={key} style={{ marginBottom: '16px' }}>
        <Session {...session} onClick={noop} />
      </div>
    ))}
  </AgendaWidget>
);

Agenda.propTypes = {
  title: PropTypes.string,
  footerProps: PropTypes.shape({
    text: PropTypes.string,
    buttonText: PropTypes.string,
  }),
  sessions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      startDateTime: PropTypes.string,
      endDateTime: PropTypes.string,
      location: PropTypes.string,
      tracks: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          color: PropTypes.string,
        }),
      ),
    }),
  ),
};

const chance = new Chance();

const generate = () => {
  const baseDate = chance.date();
  baseDate.setHours(0, 0, 0, 0);

  const startHour = chance.integer({ min: 8, max: 16 });
  const endHour = chance.integer({ min: startHour + 1, max: startHour + 4 });
  const startDateTime = new Date(baseDate);
  const endDateTime = new Date(baseDate);

  startDateTime.setHours(startHour, 0, 0, 0);
  endDateTime.setHours(endHour, 0, 0, 0);

  return {
    key: chance.hash(),
    title: chance.sentence({ words: chance.integer({ min: 6, max: 15 }) }),
    startDateTime: startDateTime.toISOString(),
    endDateTime: endDateTime.toISOString(),
    location: chance.address(),
    tracks: chance.n(
      () => ({ name: chance.city(), color: chance.color({ format: 'hex' }) }),
      chance.integer({
        min: 1,
        max: 5,
      }),
    ),
  };
};

const sessions = chance.n(generate, 3);

const Mock = ({ title }) => (
  <MockStyled>
    <Agenda
      title={title}
      footerProps={{ buttonText: t`View Your Full Schedule` }}
      sessions={sessions}
    />
  </MockStyled>
);

Mock.propTypes = {
  title: PropTypes.string,
};

export default Mock;
